/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiSanctionCheckEvent
 */
export interface InternalApiSanctionCheckEvent {
    /**
     * 
     * @type {number}
     * @memberof InternalApiSanctionCheckEvent
     */
    sanctionAlertId?: number;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiSanctionCheckEvent
     */
    createdTime: Date;
}

/**
 * Check if a given object implements the InternalApiSanctionCheckEvent interface.
 */
export function instanceOfInternalApiSanctionCheckEvent(value: object): value is InternalApiSanctionCheckEvent {
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    return true;
}

export function InternalApiSanctionCheckEventFromJSON(json: any): InternalApiSanctionCheckEvent {
    return InternalApiSanctionCheckEventFromJSONTyped(json, false);
}

export function InternalApiSanctionCheckEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiSanctionCheckEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'sanctionAlertId': json['sanctionAlertId'] == null ? undefined : json['sanctionAlertId'],
        'createdTime': (new Date(json['createdTime'])),
    };
}

export function InternalApiSanctionCheckEventToJSON(json: any): InternalApiSanctionCheckEvent {
    return InternalApiSanctionCheckEventToJSONTyped(json, false);
}

export function InternalApiSanctionCheckEventToJSONTyped(value?: InternalApiSanctionCheckEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sanctionAlertId': value['sanctionAlertId'],
        'createdTime': value['createdTime'].toISOString(),
    };
}

